<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-discounts-reporte'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-discounts-reporte"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(empleado)="data">
            <router-link
              target="_blank"
              class="text-primary"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.employee_id },
              }"
            >
              <feather-icon
                v-if="data.item.tipo_personal == 'Driver'"
                icon="TruckIcon"
                size="16"
                class="text-warning"
              />
              <feather-icon
                v-else
                icon="UserIcon"
                size="16"
                class="text-success"
              />
              {{ data.item.empleado | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7"> {{ data.item.area | capitalize }} </span
            ><br />
            <span style="opacity: 0.7" class="text-primary">
              {{ data.item.numero_documento | capitalize }}
            </span>
          </template>

          <template v-for="i in 12" #[`cell(mes_${i})`]="data">
            <span
              v-if="data.value > 0"
              :key="`mes_${i}`"
              class="cursor-pointer"
              :class="{
                'text-warning': data.item.mes_estados[`mes_${i}`],
                'text-success':
                  !data.item.mes_estados[`mes_${i}`] && data.value > 0,
                'text-muted': data.value === 0,
              }"
              @click="
                data.value > 0
                  ? openDescuentoReporteDetalle(data.item, i)
                  : null
              "
            >
              S/.{{ data.value | currency }}
            </span>
            <span :key="`mes_${i}`" v-else class="text-muted">S/.0.00</span>
          </template>

          <template #cell(total_anual)="data">
            <span v-if="data.value > 0" class="text-success">
              S/.{{ data.value | currency }}
            </span>
            <span v-else class="text-muted">S/.0.00</span>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <DescuentosReporteModal
      v-if="showDescuentoReporteDetalle"
      :modalData="detalleData"
      @hidden="showDescuentoReporteDetalle = false"
    />
  </div>
</template>

<script>
/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* Services */
import DiscountService from "@/views/commons/discounts/services/discounts.service.js";
import DescuentosReporteModal from "@/views/commons/discounts/components/modals/DescuentosReporteModal.vue";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";
export default {
  components: {
    FilterSlot,
    DescuentosReporteModal,
  },
  data() {
    return {
      filters: [
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Año",
          labelName: "label",
          options: [],
          model: null,
          cols: 12,
          reduce: "value",
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Area",
          labelName: "name",
          options: [],
          model: null,
          cols: 12,
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Discount Type",
          labelName: "name",
          options: [],
          model: null,
          cols: 12,
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Trabajador",
          labelName: "label",
          options: [],
          model: null,
          cols: 12,
          reduce: "id",
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Meses",
          labelName: "label",
          options: [
            { label: "Enero", value: 1 },
            { label: "Febrero", value: 2 },
            { label: "Marzo", value: 3 },
            { label: "Abril", value: 4 },
            { label: "Mayo", value: 5 },
            { label: "Junio", value: 6 },
            { label: "Julio", value: 7 },
            { label: "Agosto", value: 8 },
            { label: "Septiembre", value: 9 },
            { label: "Octubre", value: 10 },
            { label: "Noviembre", value: 11 },
            { label: "Diciembre", value: 12 },
          ],
          model: [],
          cols: 12,
          reduce: "value",
          multiple: true,
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Tipo Reporte",
          labelName: "label",
          options: [
            { label: "PLANIFICADO", value: "PLANIFICADO" },
            { label: "REAL", value: "REAL" },
          ],
          model: "PLANIFICADO",
          cols: 12,
          reduce: "value",
        },
      ],
      fields: [
        { key: "empleado", label: "Empleado" },
        { key: "mes_1", label: "Ene" },
        { key: "mes_2", label: "Feb" },
        { key: "mes_3", label: "Mar" },
        { key: "mes_4", label: "Abr" },
        { key: "mes_5", label: "May" },
        { key: "mes_6", label: "Jun" },
        { key: "mes_7", label: "Jul" },
        { key: "mes_8", label: "Ago" },
        { key: "mes_9", label: "Sep" },
        { key: "mes_10", label: "Oct" },
        { key: "mes_11", label: "Nov" },
        { key: "mes_12", label: "Dic" },
        { key: "total_anual", label: "Total Anual" },
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showDescuentoReporteDetalle: false,
      detalleData: {},
    };
  },
  async created() {
    await Promise.all([
      this.getAreas(), 
      this.getDiscountTypes(),
      this.getActiveEmployees(),
    ]);
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.filters[0].options = Array.from(
      { length: currentYear - 2019 },
      (_, i) => currentYear - i
    ).map((year) => ({
      label: year,
      value: year,
    }));
    this.filters[0].model = currentYear; // Set default year to current year
    this.filters[5].model = "PLANIFICADO";
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[1].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDiscountTypes() {
      try {
        const { data } = await DiscountService.getDiscountTypes();
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getActiveEmployees() {
      try {
        const { data } = await DiscountService.getActiveEmployees();
        this.filters[3].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    openDescuentoReporteDetalle(data, mes) {
      this.detalleData = data;
      // filtrar de data.descuentos_por_mes el item donde mes sea igual a mes
      const descuentosPorMes = data.descuentos_por_mes.filter(
        (item) => item.mes === mes
      );
      this.detalleData.descuentos = descuentosPorMes[0]?.descuentos || [];
      this.detalleData.mes = mes;
      this.showDescuentoReporteDetalle = true;
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();

        const params = {
          search_txt: this.filterPrincipal.model,
          page: ctx.currentPage,
          perpage: ctx.perPage,
          year: this.filters[0].model
            ? this.filters[0].model
            : new Date().getFullYear(),
          area_id: this.filters[1].model,
          discount_type_id: this.filters[2].model,
          employee_id: this.filters[3].model,
          months: this.filters[4].model,
          report_type: this.filters[5].model ? this.filters[5].model : "PLANIFICADO",
        };

        const { data } = await DiscountService.getDescuentosReporte(params);

        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;

        // 🔁 Transformar cada item para que tenga mes_1 a mes_12
        const mapped = (data.data || []).map((item) => {
          const mensual = {};
          const mes_estados = {}; // <-- Nuevo objeto

          // Inicializar con ceros y estados en false
          for (let i = 1; i <= 12; i++) {
            mensual[`mes_${i}`] = 0;
            mes_estados[`mes_${i}`] = false;
          }

          // Insertar los valores reales de cada mes y su estado
          if (Array.isArray(item.descuentos_por_mes)) {
            item.descuentos_por_mes.forEach((desc) => {
              const mes = parseInt(desc.mes);
              const monto = desc.monto_total || 0;
              const hayPendiente = desc.descuentos?.some(
                (d) => d.estado === "Not Discounted"
              );

              mensual[`mes_${mes}`] = monto;
              mes_estados[`mes_${mes}`] = hayPendiente;
            });
          }

          return {
            ...item,
            ...mensual,
            mes_estados, // <-- Agregado aquí
          };
        });

        return mapped;
      } catch (error) {
        console.error(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async exportToExcel(ctx) {
      try {
        this.addPreloader();

        const params = {
          search_txt: this.filterPrincipal.model,
          page: ctx.currentPage,
          perpage: ctx.perPage,
          year: this.filters[0].model
            ? this.filters[0].model
            : new Date().getFullYear(),
          area_id: this.filters[1].model,
          discount_type_id: this.filters[2].model,
          employee_id: this.filters[3].model,
          months: this.filters[4].model,
          report_type: this.filters[5].model ? this.filters[5].model : "PLANIFICADO",
        };
        const response = await DiscountService.exportToExcelReport(params);

        let filename = "DESCUENTOS_REPORTE.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-table-discounts-reporte"].refresh();
    },
  },
};
</script>

<style>
</style>
